import React, { useMemo } from "react";

const CatalogueContext = React.createContext(null);

function useCatalogueContextValue() {

    const [selectedCatalogues, setSelectedCatalogues] = React.useState([]);

    const toggleCatalogueSelection = (color) => {
        if (selectedCatalogues.some(sel => sel === color.id))
            setSelectedCatalogues([...selectedCatalogues.filter(sel => sel !== color.id)])
        else
            setSelectedCatalogues([...selectedCatalogues, color.id]);
    }

    return useMemo(() => {
        return {
            selectedCatalogues, toggleCatalogueSelection
        }
    }, [
        selectedCatalogues, toggleCatalogueSelection
    ]);
}

function CatalogueProvider({ ...props }) {
    const value = useCatalogueContextValue();
    return <CatalogueContext.Provider value={value} {...props}>{props.children}</CatalogueContext.Provider>;
}

function useCatalogue() {
    const context = React.useContext(CatalogueContext);
    if (!context) throw new Error('useCatalogue must be used within a CatalogueProvider');
    return context;
}

export {
    CatalogueProvider,
    useCatalogue
}